import { IconAward, IconLuggage, IconMessageCircle, IconUserCircle, IconUsersGroup } from "@tabler/icons-react";
import { rt } from "../residents-text";
import { useSession } from "../session";
import { useUnread } from "../unread";

export function Header({ path }: { path: string }) {
  const { brand, me, t, lang } = useSession();
  // The Residents section lives on Azores Getaways only (docs/22 §12).
  const residents = brand?.code === "azores-getaways";
  const signedIn = !!me;
  const onConversation = path === "/conversation";
  // The conversation page loads the thread itself; elsewhere the header checks for new replies.
  const unread = useUnread(!!me && me.session.kind === "full" && !onConversation);
  return (
    <header className="header">
      <a href="/" className="header-brand" aria-label={brand?.name ?? t("appName")}>
        {brand ? <img src={brand.logoUrl} alt={brand.name} className="header-logo" /> : <span className="header-title">{t("appName")}</span>}
      </a>
      {signedIn && (
        <nav className="header-nav" aria-label="Main">
          <a href="/" className={path === "/" || path.startsWith("/trips") ? "active" : ""}>
            <IconLuggage size={20} stroke={1.75} />
            <span>{t("navHome")}</span>
          </a>
          <a href="/conversation" className={onConversation ? "active" : ""}>
            <span className="nav-icon">
              <IconMessageCircle size={20} stroke={1.75} />
              {unread && !onConversation && <span className="nav-dot" aria-label={t("unread")} />}
            </span>
            <span>{t("navMessages")}</span>
          </a>
          {residents && (
            <a href="/residents" className={path === "/residents" ? "active" : ""}>
              <IconUsersGroup size={20} stroke={1.75} />
              <span>{rt(lang, "nav")}</span>
            </a>
          )}
          <a href="/club" className={path === "/club" ? "active" : ""}>
            <IconAward size={20} stroke={1.75} />
            <span>{t("navClub")}</span>
          </a>
          <a href="/account" className={path === "/account" ? "active" : ""}>
            <IconUserCircle size={20} stroke={1.75} />
            <span>{t("navAccount")}</span>
          </a>
        </nav>
      )}
    </header>
  );
}
